import axios from "axios";

// export const baseURL = "https://testedoacao.fiecdev.com.br:40001";
export const baseURL = "https://doacaosangue.fiecdev.com.br:24000"; //prod

const api = axios.create({
  baseURL: baseURL,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.authorization = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
